import React, { Component } from 'react';
import Button from 'components/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

export class CreateBookingButton extends Component {
  handleClick = () => {
    const { onClick, createBooking } = this.props;

    onClick(createBooking);
  };

  render() {
    const { loading, isWaitListBooking, disabled } = this.props;

    return (
      <Button
        onClick={this.handleClick}
        disabled={loading || disabled}
        block
        secondary
      >
        {loading ? (
          <span>
            <FontAwesomeIcon icon="spinner" spin />{' '}
            {isWaitListBooking
              ? 'SUBMITTING WAITLIST REQUEST...'
              : 'Booking ...'}
          </span>
        ) : isWaitListBooking ? (
          'SUBMIT WAITLIST REQUEST'
        ) : (
          'Book Now'
        )}
      </Button>
    );
  }
}

CreateBookingButton.propTypes = {
  loading: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  createBooking: PropTypes.func.isRequired,
  isWaitListBooking: PropTypes.bool,
  disabled: PropTypes.bool
};

export default CreateBookingButton;
